import React, { useEffect, useState } from "react";
import axios from "axios";

const FPS_Details = ({ officeCode, status, distName, afsoName }) => {
  const [fpsData, setFpsData] = useState([]);
  const [error, setError] = useState(null);
  const [perPage, setPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (!officeCode || !status) return;

    const fetchFpsDetails = async () => {
      setError(null);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL_FPS}/api/fps/afsoOwnerDetails`,
          { params: { officeCode, status } }
        );
        setFpsData(response.data);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch FPS details");
      }
    };

    fetchFpsDetails();
  }, [officeCode, status]);

  const handlePrint = () => {
    window.print();
  };

  const totalEntries = fpsData.length;
  const totalPages = Math.ceil(totalEntries / perPage);

  const filteredFpsData = fpsData.filter(
    (fps) =>
      (fps.fpsId?.toString() || "").includes(search) ||
      (fps.totalCards?.toString() || "").includes(search) ||
      (fps.terminalId || "").toLowerCase().includes(search.toLowerCase()) ||
      (fps.ownerNameEn || "").toLowerCase().includes(search.toLowerCase()) ||
      (fps.mobileNo || "").includes(search)
  );

  const indexOfLastEntry = currentPage * perPage;
  const indexOfFirstEntry = indexOfLastEntry - perPage;
  const paginatedData =
    perPage === "ALL"
      ? filteredFpsData
      : filteredFpsData.slice(indexOfFirstEntry, indexOfLastEntry);

  const startEntry = Math.min(
    (currentPage - 1) * perPage + 1,
    filteredFpsData.length
  );
  const endEntry = Math.min(
    currentPage * perPage,
    filteredFpsData.length
  );

  const paginationText = `Showing ${startEntry} to ${endEntry} of ${filteredFpsData.length} entries`;

  const goToFirstPage = () => setCurrentPage(1);
  const goToLastPage = () => setCurrentPage(totalPages);
  const goToPreviousPage = () => setCurrentPage((prev) => Math.max(1, prev - 1));
  const goToNextPage = () => setCurrentPage((prev) => Math.min(totalPages, prev + 1));

  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (!fpsData.length) return <p>No FPS data found.</p>;

  const paginationButtonStyle = {
    padding: "5px 15px",
    margin: "0 2px",
    backgroundColor: "#2e488a",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    textDecoration: "underline",
    fontWeight: "bold",
  };

  const activePageStyle = {
    ...paginationButtonStyle,
    backgroundColor: "#1c2b53",
    color: "white",
    textDecoration: "none",
    cursor: "default",
  };

  const disabledButtonStyle = {
    ...paginationButtonStyle,
    opacity: 0.5,
    cursor: "not-allowed",
  };

  return (
    <div style={{ marginTop: "30px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "0 20px",
          marginBottom: "10px",
          position: "relative",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            margin: "0 auto",
          }}
        >
          <span>Per page:</span>
          <select
            value={perPage}
            onChange={(e) => {
              setPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            {[10, 25, 50, 100].map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </select>
        </div>

        <div
          style={{
            position: "absolute",
            right: "250px",
            bottom: "5px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <button onClick={handlePrint}>Print</button>
          <div>
            <span>Search:</span>
            <input
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>
        </div>
      </div>
      <table
        border="1"
        cellPadding="5"
        style={{ borderCollapse: "collapse", width: "70%", margin: "0 auto" }}
      >
        <thead>
          <tr className="tableheader">
            <th colSpan="8" style={{ padding: "10px" }}>
              <span style={{ color: "white", fontWeight: "bold" }}>
                FPS Details for{" "}
              </span>
              <span style={{ color: "orange", fontWeight: "bold" }}>
                {distName}
              </span>
              <span style={{ color: "orange", fontWeight: "bold" }}>
                {" "} / {afsoName}
              </span>
            </th>
          </tr>

          <tr
            className="tableheader"
          >
            <th>Sl.No</th>
            <th>FPS</th>
            <th>Total Cards</th>
            <th>Terminal Id</th>
            <th>Owner Name</th>
            <th>Mobile</th>
            <th>longitude</th>
            <th>latitude</th>

          </tr>
        </thead>

        <tbody>
          {paginatedData.length > 0 ? (
            paginatedData.map((fps, index) => (
              <tr key={fps.fpsId}>
                <td align="center">
                  {(currentPage - 1) * perPage + index + 1}
                </td>
                <td align="center">{fps.fpsId}</td>
                <td align="right">{fps.totalCards}</td>
                <td align="center">{fps.terminalId || "NA"}</td>
                <td align="left">{fps.ownerNameEn}</td>
                <td align="center">{fps.mobileNo || "NA"}</td>
                <td align="center">{fps.longitude || "NA"}</td>
                <td align="center">{fps.latitude || "NA"}</td>

              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" align="center" color="red">
                No matching records found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "70%",
          margin: "10px auto",
          marginTop: "15px",
        }}
      >
        <div style={{ fontWeight: "bold", color: "#8B0000" }}>
          {paginationText}
        </div>

        <div>
          <button
            style={currentPage === 1 ? disabledButtonStyle : paginationButtonStyle}
            onClick={goToFirstPage}
            disabled={currentPage === 1}
          >
            First
          </button>
          <button
            style={currentPage === 1 ? disabledButtonStyle : paginationButtonStyle}
            onClick={goToPreviousPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <button style={activePageStyle}>
            {currentPage}
          </button>
          <button
            style={currentPage === totalPages ? disabledButtonStyle : paginationButtonStyle}
            onClick={goToNextPage}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
          <button
            style={currentPage === totalPages ? disabledButtonStyle : paginationButtonStyle}
            onClick={goToLastPage}
            disabled={currentPage === totalPages}
          >
            Last
          </button>
        </div>
      </div>
    </div>
  );
};

export default FPS_Details;